import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { formatText, HtmlText } from 'core/i18n';
import React from 'react';
import { getTextMessageByVideoStatusCode } from 'utilities/video/getTextMessageByStatusCode';
import { DEFAULT_EXTRA_MESSAGE_QR_FLOW, EXTRA_MESSAGE_QR_FLOW_ERROR } from 'constants/video/statusTexts';

export const ErrorMessage = ({ statusCode, documentType }) => {
    const message = getTextMessageByVideoStatusCode({ isVideoSelfie: true, documentType, statusCode });
    const extraMessage = EXTRA_MESSAGE_QR_FLOW_ERROR[statusCode] ?? DEFAULT_EXTRA_MESSAGE_QR_FLOW;

    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-warning"
                title={formatText('identity-errorQRCaptureTitle')}
                subtitle={HtmlText(formatText(message.content))}
                dashTitle={false}
                showFooter={false}
            >
                {HtmlText(formatText(extraMessage))}
            </MessagesScreen>
        </div>
    );
};
